import { Injectable } from '@angular/core';
import {
  PrismicUtils,
  PrismicRichText,
  LogService,
  Log,
} from '@segurosvoluntarios_vel/commons-services';
import { ContenidoDePagos } from 'src/app/pago/models/ContenidoDePagos.model';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ContentNotFoundException } from 'src/app/pago/models/exceptions/ContentNotFoundException';
import { MensajeError } from 'src/app/pago/enums/MensajeError.enum';
import { ContenidoDeEstadoDePago } from 'src/app/pago/models/ContenidoDeEstadoDePago.model';
import { ContenidoEstadosDTO } from 'src/app/pago/dtos/ContenidoEstadosDTO.model';
import { ContenidoEstadoPagoFactory } from 'src/app/pago/factories/contenido-estado-pago/contenido-estado-pago.factory';
import * as allContenido_de_pagoss from 'src/app/shared/prismic/allContenido-de-pagoss.json';

@Injectable({
  providedIn: 'root',
})
export class ContenidoPagosService {
  constructor(
    private prismicUtils: PrismicUtils,
    // private corePrismicGraphQlService: PrismicGraphqlService,
    private contenidoEstadoPagoFactory: ContenidoEstadoPagoFactory,
    private logservie: LogService
  ) {}

  // getContenido = (
  //   tenant: string,
  //   productName: string
  // ): Observable<ContenidoDePagos> => {
  //   return from(
  //     this.corePrismicGraphQlService.executeQuery(
  //       contenidoDePagosQuery(tenant, productName)
  //     )
  //   ).pipe(
  //     take(1),
  //     map(documents => {
  //       const result: any = this.prismicUtils.convertKeyNamesToCamelCase(
  //         documents.data.allContenido_de_pagoss.edges[0].node
  //       );

  //       return {
  //         ...result,
  //         contenidoEstados: this.normalizeEstadosPago(
  //           result.contenidoEstadosPago.contenidoEstados,
  //           result.textoEncuestaDeSatisfaccion
  //         ),
  //       };
  //     }),
  //     catchError(error => {
  //       const body: Log = {
  //         body: JSON.stringify(error.error),
  //         origen: 'pagos-mf',
  //         tenant: tenant,
  //         producto: productName,
  //         transactionId: error.error?.requestId,
  //       };
  //       this.logservie.error(body);
  //       return throwError(
  //         new ContentNotFoundException(
  //           MensajeError.NO_SE_PUDO_CARGAR_EL_CONTENIDO
  //         )
  //       );
  //     })
  //   );
  // };

  getContenido = (
    tenant: string,
    productName: string
  ): Observable<ContenidoDePagos> => {
    const dataPagos =
      allContenido_de_pagoss.default.data.allContenido_de_pagoss.edges[0]?.node;

    const result: any = this.prismicUtils.convertKeyNamesToCamelCase(dataPagos);

    return of(result).pipe(
      map(result => ({
        ...result,
        contenidoEstados: this.normalizeEstadosPago(
          result.contenidoEstadosPago.contenidoEstados,
          result.textoEncuestaDeSatisfaccion
        ),
      })),
      catchError(error => {
        const body: Log = {
          body: JSON.stringify(error.error),
          origen: 'pagos-mf',
          tenant: tenant,
          producto: productName,
          transactionId: error.error?.requestId,
        };
        this.logservie.error(body);
        return throwError(
          () =>
            new ContentNotFoundException(
              MensajeError.NO_SE_PUDO_CARGAR_EL_CONTENIDO
            )
        );
      })
    );
  };

  private normalizeEstadosPago(
    contenidoEstados: ContenidoEstadosDTO[],
    textoEncuestaDeSatisfaccion: PrismicRichText[]
  ): ContenidoDeEstadoDePago[] {
    return contenidoEstados.map(contenidoEstado => {
      return this.contenidoEstadoPagoFactory.convertToModel({
        ...contenidoEstado,
        textoEncuestaDeSatisfaccion,
      });
    });
  }
}
